import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MainLayout } from './components/layout/layout';

// Auth Imports
import { LoginForm } from './components/LoginForm';
import { RegisterForm } from './components/RegisterForm';

// Dashboard Imports
import { AdminDashboard } from './dashboard/AdminDashboard';
import { ModeratorDashboard } from './dashboard/ModeratorDashboard';
import { SuperAdminDashboard } from './dashboard/SuperAdminDashboard';

// All other imports remain same...
import { QurbaniForm } from './components/QurbaniForm';
import { RegistrationOptions } from './components/RegistrationOptions';
import { ViewRegistration } from './components/ViewRegistration';
import { EditRegistration } from './components/EditRegistration';
import { FindShare } from './components/moderator/booking/FindShare';
import { AddNew } from './components/moderator/booking/AddNew';
import { ManualBooking } from './components/moderator/booking/manualBooking'; // Sahi capital 'M'
import { ViewCustomer } from './components/moderator/booking/ViewCustomer';
import { ViewShare } from './components/moderator/booking/ViewShare';
import { Slip } from './components/moderator/booking/Slip';
import AddExpense from './components/expense/AddExpense';
import ViewExpense from './components/expense/ViewExpense';
import { EditExpense } from './components/expense/EditExpense';
import AddService from './components/otherservices/AddService';
import ViewService from './components/otherservices/ViewService';
import EditService from './components/otherservices/EditService';
import ViewPayment from './components/moderator/payment/ViewPayment';
import { PaymentHistory } from './components/moderator/payment/PaymentHistory';
import { CustomerRegistrationForm } from './components/moderator/booking/CustomerRegistrationForm';
import AddIncome from './components/otherIncome/AddIncome';
import { ViewIncome } from './components/otherIncome/ViewIncome';
import EditIncome from './components/otherIncome/EditIncome';
import AddSupplier from './components/supplier/AddSupplier';
import EditSupp from './components/supplier/EditSupplier';
import { ViewSupplier } from './components/supplier/ViewSupplier';
import { SupLedger } from './components/supplier/sup_ledger';
import { PrintLedger } from './components/supplier/print_ledger';
import SupplierPayment from './components/supplier/SupplierPayment';
import AddPayment from './components/supplier/AddPayment';
import { AddButcher } from './components/butcher/AddButcher';
import { ViewButcher } from './components/butcher/ViewButcher';
import { EditButcher } from './components/butcher/editButcher';
import ButcherPayment from './components/butcher/ButcherPayment';
import GenerateSlip from './components/butcher/generateSlip';
import AddbutcherPayment from './components/butcher/AddPayment';
import { AddHoldAnimal } from './components/holdAnimal/AddHoldAnimal';
import { ViewHoldAnimals } from './components/holdAnimal/ViewHoldAnimals';
import { AnimalBookingForm } from './components/holdAnimal/AnimalBooking';
import { ViewShareforHold } from './components/holdAnimal/ViewShareforHold';
import { AddSubcategory } from './components/subcategories/AddSubcategory';
import { ViewSubcategories } from './components/subcategories/ViewSubcategories';
import { EditSubcategory } from './components/subcategories/EditSubcategory';
import { ShareStatus } from './components/reports/ShareStatus';
import { Weight } from './components/reports/Weight';
import { SlaughterWeight } from './components/reports/SlaughterWeight';
import { DailyShareCount } from './components/reports/DailyShareCount';
import { AddUser } from './components/user/AddUser';
import { ViewUsers } from './components/user/ViewUsers';
import { WeightAdd } from './components/reports/WeightAdd';
import { WeightPrint } from './components/reports/WeightPrint';
import { Fisabilillah } from './components/reports/fisabilillah';
import { EditShares } from './components/moderator/booking/EditShare';
import { DeliveryReport } from './components/reports/DeliveryReport';
import { DeliveryPrint } from './components/reports/DeliveryPrint';
import { ViewAnimalStatus } from './components/eidday/ViewAnimalStatus';
import { EiddayDashboard } from './dashboard/EiddayDashboard';
import InsertStatus from './components/eidday/InsertAnimalStatus';
import FinalSlip from './components/supplier/finalSlip';



function App() {
  return (
    <Router>
      <Routes>
        {/* 1. PUBLIC ROUTES (No Sidebar/Navbar) */}
        <Route path="/" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/slip" element={<Slip />} />
        <Route path="/printFinalSlip" element={<FinalSlip />} />
        <Route path="/butcher/slip" element={<GenerateSlip />} />
        <Route path="/reports/print" element={<WeightPrint />} />
        <Route path="/reports/deliveryPrint" element={<DeliveryPrint />} />
        <Route path="/reports/fisabilillah" element={<Fisabilillah />} />
        <Route path="/status" element={<ViewAnimalStatus />} />



        {/* 2. PROTECTED ROUTES (Using MainLayout) */}
        <Route element={<MainLayout />}>
          <Route path="/moderator-dashboard" element={<ModeratorDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/eidday" element={<EiddayDashboard />} />
          <Route path="/super-admin" element={<SuperAdminDashboard />} />
          <Route path="/add-qurbani" element={<QurbaniForm />} />

          {/* Booking & Registration */}
          <Route path="/registration-options" element={<RegistrationOptions />} />
          <Route path="/view-registration" element={<ViewRegistration />} />
          <Route path="/edit-registration" element={<EditRegistration />} />
          <Route path="/moderator/find-share" element={<FindShare />} />
          <Route path="/moderator/add-new" element={<AddNew />} />
          <Route path="/moderator/view-customer" element={<ViewCustomer />} />
          <Route path="/moderator/view-share" element={<ViewShare />} />
          <Route path="/moderator/view-payment" element={<ViewPayment />} />
          <Route path="/moderator/Edit/:id" element={<EditShares />} />
          <Route path="/moderator/payment-history" element={<PaymentHistory />} />
          <Route path="/moderator/booking/:customerId" element={<CustomerRegistrationForm />} />
          <Route path="/manual-booking/:id" element={<ManualBooking />} />
          {/* Expense & Income */}
          <Route path="/expense/add-expense" element={<AddExpense />} />
          <Route path="/expense/view-expense" element={<ViewExpense />} />
          <Route path="/expense/edit/:id" element={<EditExpense />} />
          <Route path="/other-income/add" element={<AddIncome />} />
          <Route path="/other-income/view" element={<ViewIncome />} />
          <Route path="/other-income/edit/:id" element={<EditIncome />} />

          {/* Services */}
          <Route path="/othService/add" element={<AddService />} />
          <Route path="/othService/view" element={<ViewService />} />
          <Route path="/othService/edit/:id" element={<EditService />} />

          {/* Supplier & Butcher */}
          <Route path="/supplier/add" element={<AddSupplier />} />
          <Route path="/supplier/view" element={<ViewSupplier />} />
          <Route path="/supplier/new-payment" element={<AddPayment />} />
          <Route path="/supplier/sup-ledger" element={<SupLedger />} />
          <Route path="/supplier/print-ledger" element={<PrintLedger />} />
          <Route path="/supplier/payment" element={<SupplierPayment />} />
          <Route path="/supplier/edit/:id" element={<EditButcher />} />
          <Route path="/butcher/add" element={<AddButcher />} />
          <Route path="/butcher/view" element={<ViewButcher />} />
          <Route path="/butcher/edit/:id" element={<EditButcher />} />
          <Route path="/butcher/new-payment" element={<AddbutcherPayment />} />
          <Route path="/butcher/payment" element={<ButcherPayment />} />

          {/* Animal Holding */}
          <Route path="/hold-animal/add" element={<AddHoldAnimal />} />
          <Route path="/hold-animal/view" element={<ViewHoldAnimals />} />
          <Route path="/hold/:id" element={<AnimalBookingForm />} />
          <Route path="/hold/viewShareforHold" element={<ViewShareforHold />} />

          {/* Reports & Settings */}
          <Route path="/subcategories/add" element={<AddSubcategory />} />
          <Route path="/subcategories/view" element={<ViewSubcategories />} />
          <Route path="/subcategories/edit/:id" element={<EditSubcategory />} />
          <Route path="/reports/share-status" element={<ShareStatus />} />
          <Route path="/reports/weight" element={<Weight />} />
          <Route path="/reports/Delivery" element={<DeliveryReport />} />
          <Route path="/reports/WeightAdd" element={<WeightAdd />} />
          <Route path="/reports/slaughter-weight" element={<SlaughterWeight />} />
          <Route path="/reports/daily-share" element={<DailyShareCount />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/view" element={<ViewUsers />} />

          <Route path="/eidday/insert-status" element={<InsertStatus />} />


        </Route>


      </Routes>
    </Router>
  );
}

export default App;